// Still frames for every clip on the site (Sep 30, 2026). iPhone and iPad in Low Power Mode
// refuse to autoplay video, and with preload="metadata" Safari then shows an empty box. Each
// <video> takes its poster from here, so the card or frame always shows a picture.
import questMp4 from "./vimbal_quest_office.mp4";
import ndisMp4 from "./vimbal_ndis_wheelchair.mp4";
import calmMp4 from "./vimbal_video_five.mp4";
import neuroMp4 from "./vimbal_video_three.mp4";
import workMp4 from "./vimbal_induction_site.mp4";
import militaryMp4 from "./vimbal_military.mp4";
import womanMp4 from "./vimbal_neuro_woman.mp4";
import studyMp4 from "./vimbal_study_laptop.mp4";
import questJpg from "./posters/vimbal_quest_office.jpg";
import ndisJpg from "./posters/vimbal_ndis_wheelchair.jpg";
import calmJpg from "./posters/vimbal_video_five.jpg";
import neuroJpg from "./posters/vimbal_video_three.jpg";
import workJpg from "./posters/vimbal_induction_site.jpg";
import militaryJpg from "./posters/vimbal_military.jpg";
import womanJpg from "./posters/vimbal_neuro_woman.jpg";
import studyJpg from "./posters/vimbal_study_laptop.jpg";

// The glasses turntable has a transparent background, so its still is a PNG with alpha.
export { default as glassesStill } from "./posters/glasses.png";

const POSTERS = {
  [questMp4]: questJpg,
  [ndisMp4]: ndisJpg,
  [calmMp4]: calmJpg,
  [neuroMp4]: neuroJpg,
  [workMp4]: workJpg,
  [militaryMp4]: militaryJpg,
  [womanMp4]: womanJpg,
  [studyMp4]: studyJpg,
};

export const posterFor = (src) => POSTERS[src];
